import { render, staticRenderFns } from "./LicenseSelectComponent.vue?vue&type=template&id=53eb3538&scoped=true"
import script from "./LicenseSelectComponent.vue?vue&type=script&lang=ts"
export * from "./LicenseSelectComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb3538",
  null
  
)

export default component.exports